import axios from 'axios'

export const SystemParameterApi = {
    async Update(data){
        const response = await axios.post('/api/systemparameter/update',data)
        return response
    },
    async List(){
        const response = await axios.get(`/api/systemparameter/list`)
        return response
    },
    MarketingType:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/systemparameter/marketingtype/update':'/api/systemparameter/marketingtype/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/systemparameter/marketingtype/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/systemparameter/marketingtype/table`,data)
            return response
        },
        async List(){
            const response = await axios.get(`/api/systemparameter/marketingtype/list`)
            return response
        },
    },
    MarketingTypeQuestion:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/systemparameter/marketingtypequestion/update':'/api/systemparameter/marketingtypequestion/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/systemparameter/marketingtypequestion/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/systemparameter/marketingtypequestion/table`,data)
            return response
        },
        async List(){
            const response = await axios.get(`/api/systemparameter/marketingtypequestion/list`)
            return response
        },
        async ListById(data){
            const response = await axios.get(`/api/systemparameter/marketingtypequestion/listbymarketingtype/${data}`)
            return response
        },
    },
    MarketingTypeQuestionAnswer:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/systemparameter/answerofmarketingtypequestion/update':'/api/systemparameter/answerofmarketingtypequestion/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/systemparameter/answerofmarketingtypequestion/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/systemparameter/answerofmarketingtypequestion/table`,data)
            return response
        },
        async List(){
            const response = await axios.get(`/api/systemparameter/answerofmarketingtypequestion/list`)
            return response
        },
        async ListByQuestion(mtId,mtqId){
            const response = await axios.get(`/api/systemparameter/answerofmarketingtypequestion/listbyanswerofmarketingtypequestion/${mtId}/${mtqId}`)
            return response
        }
    },
    Sector:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/systemparameter/sector/update':'/api/systemparameter/sector/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/systemparameter/sector/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/systemparameter/sector/table`,data)
            return response
        },
        async List(){
            const response = await axios.get(`/api/systemparameter/sector/list`)
            return response
        },
    },
    Colour:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/systemparameter/colour/update':'/api/systemparameter/colour/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/systemparameter/colour/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post(`/api/systemparameter/colour/table`,data)
            return response
        },
        async List(){
            const response = await axios.get(`/api/systemparameter/colour/list`)
            return response
        },
    },
}